import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { AlertTriangle } from 'lucide-react';
import { t } from '@/i18n';

export const OeeOverlay = ({ oee = 77.6, breakdown, totalThroughput, alertCount = 0 }) => {
  const data = [
    { value: oee },
    { value: 100 - oee },
  ];

  const metrics = breakdown || {
    availability: 92,
    performance: 85,
    quality: 99.2,
  };

  return (
    <div className="absolute top-4 left-4 z-10 bg-white/85 backdrop-blur-md border border-border rounded-xl shadow-elevated p-3 w-[160px]">
      <div className="flex items-center justify-between mb-1">
        <div className="text-[11px] font-semibold text-muted-foreground">{t('oee.plantOee')}</div>
        {alertCount > 0 && (
          <div className="flex items-center gap-1 text-[10px] font-semibold text-orange-600 bg-orange-50 px-1.5 py-0.5 rounded-full">
            <AlertTriangle className="h-3 w-3" />
            {alertCount}
          </div>
        )}
      </div>
      <div className="relative w-[80px] h-[80px] mx-auto">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={28}
              outerRadius={38}
              startAngle={90}
              endAngle={-270}
              dataKey="value"
              stroke="none"
            >
              <Cell fill="hsl(var(--chart-1))" />
              <Cell fill="#e5e7eb" />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-lg font-extrabold tracking-tight" style={{ fontVariantNumeric: 'tabular-nums' }}>{oee}%</span>
        </div>
      </div>
      <div className="mt-2 space-y-1">
        {[
          { label: t('oee.availability'), value: `${metrics.availability}%`, color: '#3b82f6' },
          { label: t('oee.performance'), value: `${metrics.performance}%`, color: '#22c55e' },
          { label: t('oee.quality'), value: `${metrics.quality}%`, color: '#8b5cf6' },
        ].map(item => (
          <div key={item.label} className="flex items-center justify-between text-[10px]">
            <div className="flex items-center gap-1">
              <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: item.color }} />
              <span className="text-muted-foreground">{item.label}</span>
            </div>
            <span className="font-semibold" style={{ fontVariantNumeric: 'tabular-nums' }}>{item.value}</span>
          </div>
        ))}
      </div>
      {totalThroughput != null && (
        <div className="mt-2 pt-2 border-t border-border/50 flex items-center justify-between text-[10px]">
          <span className="text-muted-foreground">{t('oee.throughput')}</span>
          <span className="font-semibold" style={{ fontVariantNumeric: 'tabular-nums' }}>{totalThroughput} t/h</span>
        </div>
      )}
    </div>
  );
};
